export default __webpack_public_path__ + "static/media/out2.98a55d57.mp3";